<ul class="pagination" *ngIf="pageNumber > 1">
  <li *ngIf="currentPage === 1; else previous" class="page-item previous disabled">
    <span class="show-md"><i class="fa fa-angle-left"></i></span>
    <span class="hide-md">{{ 'pagination.previous' | translate }}</span>
  </li>
  <ng-template #previous>
    <li class="page-item previous">
      <a class="show-md" (click)="onPageClick(currentPage - 1)"><i class="fa fa-angle-left"></i></a>
      <a class="hide-md" (click)="onPageClick(currentPage - 1)">{{ 'pagination.previous' | translate }}</a>
    </li>
  </ng-template>
  <li *ngIf="pages[0] > 1" class="page-item" [ngClass]="{'active': page === currentPage}">
    <a (click)="onPageClick(1)">{{ 1 }}</a>
  </li>
  <li *ngIf="pages[0] > 2" class="page-item page-item-separator">
    <span>&hellip;</span>
  </li>
  <li class="page-item" *ngFor="let page of pages" [ngClass]="{'active': page === currentPage}">
    <a (click)="onPageClick(page)">{{ page }}</a>
  </li>
  <li *ngIf="pages.slice(-1)[0] < pageNumber - 1" class="page-item page-item-separator">
    <span>&hellip;</span>
  </li>
  <li *ngIf="pages.slice(-1)[0] < pageNumber" class="page-item" [ngClass]="{'active': page === currentPage}">
    <a (click)="onPageClick(pageNumber)">{{ pageNumber }}</a>
  </li>
  <li *ngIf="currentPage === pageNumber; else next" class="page-item next disabled">
    <span class="hide-md">{{ 'pagination.next' | translate }}</span>
    <span class="show-md"><i class="fa fa-angle-right"></i></span>
  </li>
  <ng-template #next>
    <li class="page-item next">
      <a class="hide-md" (click)="onPageClick(currentPage + 1)">{{ 'pagination.next' | translate }}</a>
      <a class="show-md" (click)="onPageClick(currentPage + 1)"><i class="fa fa-angle-right"></i></a>
    </li>
  </ng-template>
</ul>
